import { Button, Input, InteractiveIcon, List, Thumbnail } from '@bynder/design-system';
import { IconCancel, IconCheck, IconEdit, IconTitle } from '@bynder/icons';
import React from 'react';

export const InspectorTitleEditor: React.FC<{
  testId: string;
  onEdit: (newTitle: string) => void;
  propTitle: string;
  subText?: string;
}> = ({ testId, onEdit, propTitle, subText = '' }) => {
  const [title, setTitle] = React.useState(propTitle);
  const [isEditing, setIsEditing] = React.useState(false);

  const handleEdit = () => {
    onEdit(title);
    setIsEditing(false);
  };
  const handleOnKeyDownPage = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onEdit(title);
      setIsEditing(false);
    } else if (e.key === 'Escape') {
      setIsEditing(false);
      setTitle(propTitle);
    }
  };
  return (
    <>
      <List.Item
        thumbnail={!isEditing && <Thumbnail shape="square" icon={<IconTitle />} />}
        subtext={!isEditing && subText}
        rightElements={
          isEditing ? (
            <>
              <Button
                aria-label="Cancel"
                variant="secondary"
                icon={<IconCancel />}
                onClick={() => setIsEditing(false)}
              />
              <Button
                data-testid="submitButton"
                aria-label="Save"
                variant="primary"
                icon={<IconCheck />}
                onClick={handleEdit}
              />
            </>
          ) : (
            <InteractiveIcon
              icon={<IconEdit />}
              onClick={() => setIsEditing(true)}
              label="Edit"
              data-testid={`${testId}Edit`}
            />
          )
        }
      >
        {isEditing ? (
          <Input
            data-testid={`${testId}Input`}
            autoFocus
            value={title}
            onChange={setTitle}
            onKeyDown={handleOnKeyDownPage}
          />
        ) : (
          propTitle
        )}
      </List.Item>
    </>
  );
};
